import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { AuthContext } from "../../context/AuthContext";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { Box, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import PulseLoader from "react-spinners/PulseLoader";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getDataWithToken } from "../../services/GetDataService";
import IconButton from "@mui/material/IconButton";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { designationList, roleList } from "../../data";
import { handlePostData } from "../../services/PostDataService";
import ImageUpload from "../../utils/ImageUpload";
import MetaTagAndDescription from "../../components/MetaTagAndDescription";

const form = {
  padding: "50px",
  background: "#fff",
  borderRadius: "10px",
  width: "400px",
  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
};
const AddDevice = ({ clearFilter }) => {
  const navigate = useNavigate();

  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);

  const [addDialog, setAddDialog] = useState(false);
  const [name, setName] = useState("");
  const [parent_id, setParent_id] = useState("");
  const [deviceBrandId, setDeviceBrandId] = useState("");
  const [deviceBrandList, setDeviceBrandList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [file, setFile] = useState(null);
  const [image_alt_text, setImage_alt_text] = useState("");
  const [iconFile, setIconFile] = useState(null);
  const [loading2, setLoading2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orderNo, setOrderNo] = useState();
  const dropzoneRef = useRef(null);
  const [endpoint, setEndpoint] = useState("");
  const [message, setMessage] = useState("");

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [pageDescription, setPageDescription] = useState("");
  const [pageTitle, setPageTitle] = useState("");
  const [pageTitleDescription, setPageTitleDescription] = useState("");

  const { enqueueSnackbar } = useSnackbar();

  const handleDialogClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setAddDialog(false);
    }
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const clearForm = () => {
    setName("");
    setOrderNo();
    setEndpoint("");
    setParent_id("");
    setDeviceBrandId("");
    setFile(null);
    setImage_alt_text("");
    setIconFile(null);
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    let formdata = new FormData();
    formdata.append("name", name.trim());

    formdata.append("endpoint", endpoint);
    if (deviceBrandId) {
      formdata.append("device_brand_id", deviceBrandId);
    }

    formdata.append("parent_id", parent_id === "None" ? "" : parent_id);
    formdata.append("meta_title", metaTitle);
    formdata.append("meta_description", metaDescription);
    formdata.append("meta_keywords", metaKeywords);
    formdata.append("page_description", pageDescription);
    formdata.append("page_title", pageTitle);
    formdata.append("page_title_description", pageTitleDescription);
    formdata.append("order_no", orderNo);
    formdata.append("image_alt_text", image_alt_text.trim());
    if (file) {
      formdata.append("image", file);
    }
    if (iconFile) {
      formdata.append("icon", iconFile);
    }

    // let data = {
    //   name: name.trim(),
    //   parent_name: parent_id.trim(),
    // };

    let response = await handlePostData(
      "/api/v1/device/create",
      formdata,
      true
    );

    console.log("response", response);
    if (response?.status === 401) {
      logout();
      return;
    }
    if (response.status >= 200 && response.status < 300) {
      handleSnakbarOpen("Added successfully", "success");
      navigate("/device-list");

      clearForm();
      handleDialogClose();
    } else {
      handleSnakbarOpen(response?.data?.message, "error");
    }

    setLoading(false);
    // }
  };

  const customeTextFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    // padding: "15px 20px",

    // "& label.Mui-focused": {
    //   color: "#A0AAB4",
    // },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "15px 24px 15px 0px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const customeSelectFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",

    "& label.Mui-focused": {
      color: "#E5E5E5",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "10px 16px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "#",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const getDropdownList = async () => {
    setLoading2(true);

    let url = `/api/v1/deviceBrand/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setDeviceBrandList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };
  const getDeviceList = async () => {
    setLoading2(true);

    let url = `/api/v1/device/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setDeviceList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };
  useEffect(() => {
    getDropdownList();
    getDeviceList();
  }, []);
  return (
    <>
      <Grid container columnSpacing={3} style={{ padding: "24px 0" }}>
        <Grid size={6}>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{ color: "#0F1624", fontWeight: 600 }}
          >
            Add Device
          </Typography>
        </Grid>
        <Grid size={6} style={{ textAlign: "right" }}></Grid>
      </Grid>

      <div
        style={{
          background: "#fff",
          border: "1px solid #EAECF1",
          borderRadius: "12px",
          overflow: "hidden",
          padding: "16px",
          boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
        }}
      >
        <form onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Device Name *
              </Typography>
              <TextField
                required
                size="small"
                fullWidth
                id="name"
                placeholder="Full Name"
                variant="outlined"
                sx={{ ...customeTextFeild, mb: 2 }}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Grid>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Order No *
              </Typography>
              <TextField
                required
                type="number"
                onWheel={(e) => e.target.blur()}
                size="small"
                fullWidth
                id="name"
                placeholder="Enter Order No"
                variant="outlined"
                sx={{ ...customeTextFeild, mb: 2 }}
                value={orderNo}
                onChange={(e) => {
                  setOrderNo(e.target.value);
                }}
              />
            </Grid>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Select Device Brand *
              </Typography>
              <FormControl
                fullWidth
                size="small"
                sx={{
                  mb: 3,
                  ...customeSelectFeild,
                  "& label.Mui-focused": {
                    color: "rgba(0,0,0,0)",
                  },

                  "& .MuiOutlinedInput-input img": {
                    position: "relative",
                    top: "2px",
                  },
                }}
              >
                {deviceBrandId?.length < 1 && (
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{ color: "#b3b3b3", fontWeight: 300 }}
                  >
                    Select Device Brand
                  </InputLabel>
                )}
                <Select
                  // required
                  labelId="demo-simple-select-label"
                  id="baseLanguage"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 250, // Set the max height here
                      },
                    },
                  }}
                  value={deviceBrandId}
                  onChange={(e) => {
                    setDeviceBrandId(e.target.value);
                  }}
                >
                  {deviceBrandList?.map((item) => (
                    <MenuItem key={item} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>{" "}
            </Grid>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Select Parent Device
              </Typography>

              <FormControl
                fullWidth
                size="small"
                sx={{
                  mb: 3,
                  ...customeSelectFeild,
                  "& label.Mui-focused": {
                    color: "rgba(0,0,0,0)",
                  },

                  "& .MuiOutlinedInput-input img": {
                    position: "relative",
                    top: "2px",
                  },
                }}
              >
                {parent_id?.length < 1 && (
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{ color: "#b3b3b3", fontWeight: 300 }}
                  >
                    Select Parent Device
                  </InputLabel>
                )}
                <Select
                  // required
                  labelId="demo-simple-select-label"
                  id="baseLanguage"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 250, // Set the max height here
                      },
                    },
                  }}
                  value={parent_id}
                  onChange={(e) => {
                    setParent_id(e.target.value);
                    setEndpoint("");
                  }}
                >
                  <MenuItem value={"None"}>None</MenuItem>
                  {deviceList
                    .filter((item) =>
                      item.name.toLowerCase().includes("series")
                    )
                    ?.map((item) => (
                      <MenuItem key={item} value={item?._id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={12}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                URL Endpoint *
                <span style={{ color: "#898989" }}>
                  {" "}
                  (e.g: /services/xxxxxx-repair)
                </span>
              </Typography>
              <TextField
                required
                size="small"
                fullWidth
                id="endpoint"
                placeholder="Enter URL Endpoint"
                variant="outlined"
                sx={{ ...customeTextFeild, mb: 2 }}
                value={endpoint}
                onChange={(e) => {
                  setEndpoint(e.target.value);
                }}
              />{" "}
            </Grid>
            <Grid size={12}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Image Alt Text
              </Typography>
              <TextField
                size="small"
                fullWidth
                id="image_alt_text"
                placeholder="Image Alt Text"
                variant="outlined"
                sx={{ ...customeTextFeild, mb: 2 }}
                value={image_alt_text}
                onChange={(e) => {
                  setImage_alt_text(e.target.value);
                }}
              />
            </Grid>
            <Grid size={12}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Device Image
              </Typography>
              <Box sx={{ mb: 3 }}>
                <ImageUpload
                  file={file}
                  setFile={setFile}
                  dimension="Size: (400 : 260)"
                />
              </Box>
              {/* <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Device Icon
          </Typography>
          <Box>
            <ImageUpload
              file={iconFile}
              setFile={setIconFile}
              dimension="Dimensions (1 : 1)"
            />
          </Box> */}
            </Grid>
          </Grid>
          <Box>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: "#0F1624", fontWeight: 600, mb: 2 }}
            >
              Meta Information and Page Description
            </Typography>
            <MetaTagAndDescription
              metaTitle={metaTitle}
              setMetaTitle={setMetaTitle}
              metaDescription={metaDescription}
              setMetaDescription={setMetaDescription}
              metaKeywords={metaKeywords}
              setMetaKeywords={setMetaKeywords}
              pageDescription={pageDescription}
              setPageDescription={setPageDescription}
              pageTitle={pageTitle}
              setPageTitle={setPageTitle}
              pageTitleDescription={pageTitleDescription}
              setPageTitleDescription={setPageTitleDescription}
            />
          </Box>
          <Box
            sx={{ p: 2, marginTop: "1px solid #EAECF0", textAlign: "right" }}
          >
            <Button
              variant="outlined"
              onClick={handleDialogClose}
              sx={{
                mr: 2,
                px: 2,
                py: 1.25,
                fontSize: "14px",
                fontWeight: 600,
                color: "#344054",
                border: "1px solid #D0D5DD",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              }}
              component={Link}
              to="/spare-parts-list"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={loading}
              type="submit"
              sx={{
                px: 2,
                py: 1.25,
                fontSize: "14px",
                fontWeight: 600,
                minWidth: "127px",
                minHeight: "44px",
              }}
              // style={{ minWidth: "180px", minHeight: "35px" }}

              disableElevation
            >
              <PulseLoader
                color={"#4B46E5"}
                loading={loading}
                size={10}
                speedMultiplier={0.5}
              />{" "}
              {loading === false && "Save changes"}
            </Button>
          </Box>
        </form>
      </div>
    </>
  );
};

export default AddDevice;
